import {ApplicationFeatures, UserRoles} from '../enums/enums';

export interface IFeatureRole {
  featureName: ApplicationFeatures;
  roles: UserRoles[];
}

const featureRoles: Record<string, any>[] =
  [
    {
      feature: ApplicationFeatures.webWidget,
      roles: [UserRoles.owner, UserRoles.manager, UserRoles.developer, UserRoles.viewer],

    },
    {
      feature: ApplicationFeatures.refundRequests,
      roles: [UserRoles.owner, UserRoles.manager, UserRoles.cashier, UserRoles.viewer],

    },
    {
      feature: ApplicationFeatures.ambassador,
      roles: [UserRoles.owner, UserRoles.manager],

    },
    {
      feature: ApplicationFeatures.sceMembership,
      roles: [UserRoles.owner, UserRoles.manager, UserRoles.viewer],

    },
    {
      feature: ApplicationFeatures.userInvitations,
      roles: [UserRoles.owner, UserRoles.manager, UserRoles.viewer],

    },
    {
      feature: ApplicationFeatures.subscriptions,
      roles: [UserRoles.owner, UserRoles.manager, UserRoles.viewer],

    },
    {
      feature: ApplicationFeatures.deals,
      roles: [UserRoles.owner, UserRoles.manager],
    },
    {
      feature: ApplicationFeatures.paymentRequestTemplates,
      roles: [UserRoles.owner, UserRoles.manager],
    },
  ];

export default featureRoles;
